import {environment} from "../../config/environment";
import { api } from "../../shared/utils";

const baseUrl = environment.apiBaseURLClients
const authBaseUrl = `${baseUrl}/auth`;

const createResetTokenResponse = (payload = {}) => ({
    data: {
        email: payload.email,
        expiresInMinutes: 10,
    },
});

export const login = (formLogin) => {
    const email = formLogin.email || formLogin.username || '';

    if (environment.disableAuth) {
        return Promise.resolve({
            data: {
                username: 'demo',
                email: email || 'demo@busifarm.com.br',
                accessToken: 'demo-token',
                expiresIn: Date.now() + 24 * 60 * 60 * 1000,
            },
        });
    }

    const uri = `${authBaseUrl}/login`;
    return api.post(uri, {
        email,
        password: formLogin.password,
        ...(environment.systemId ? { systemId: environment.systemId } : {}),
    })
}

/**
 * `POST /auth/login/refresh`: troca o token atual por outro, com validade nova, sem pedir a senha.
 *
 * O token vai no CORPO, em `refreshToken`. É o próprio access token: o identity não emite um
 * refresh token à parte. A rota é pública no gateway pelo mesmo motivo do login, porque existe
 * para o instante em que a sessão está por vencer.
 *
 * Só funciona com o token ainda VÁLIDO. Vencido, revogado, conta bloqueada ou sem licença do
 * sistema é 401, e daí o caminho é o login. Quem chama precisa renovar ANTES de vencer.
 */
export const renovarSessao = (accessToken) => api.post(`${authBaseUrl}/login/refresh`, {refreshToken: accessToken});

export const requestPasswordResetToken = ({email}) => {
    if (environment.disableAuth) {
        return Promise.resolve(createResetTokenResponse({email}));
    }

    return api.post(`${authBaseUrl}/forgot-password`, {email});
};

export const verifyPasswordResetToken = ({email, token}) => {
    if (environment.disableAuth) {
        return Promise.resolve({data: {email, token, valid: true}});
    }

    return api.post(`${authBaseUrl}/forgot-password/validate`, {email, token});
};

export const resetPassword = ({email, token, password}) => {
    if (environment.disableAuth) {
        return Promise.resolve({data: {email, token, updated: true}});
    }

    return api.post(`${authBaseUrl}/forgot-password/reset`, {
        email,
        token,
        password,
    });
};
